import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "group outline-none" }

import { ElDropdown, ElDropdownItem, ElDropdownMenu } from 'element-plus';
import { DropdownOptionType } from '~src/admin/types';
import IconCheck from '../icons/IconCheck.vue';

// Props

export default /*@__PURE__*/_defineComponent({
  __name: 'Dropdown',
  props: {
    options: {},
    menuWidth: { default: 'normal' },
    placement: { default: 'bottom' }
  },
  emits: ["selectOption"],
  setup(__props: any, { emit: __emit }) {



// Emits
const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ElDropdown), {
    "popper-class": `dropdown-menu menu-${_ctx.menuWidth}`,
    placement: (_ctx.placement as any)
  }, {
    dropdown: _withCtx(() => [
      _createVNode(_unref(ElDropdownMenu), null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option, i) => {
            return (_openBlock(), _createBlock(_unref(ElDropdownItem), {
              key: i,
              class: _normalizeClass([option.selected && 'is-selected', option?.disabled && 'is-disabled']),
              disabled: option?.disabled ?? false,
              onClick: ($event: any) => (!option?.disabled && emit('selectOption', option.label))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  (option.icon)
                    ? (_openBlock(), _createBlock(_resolveDynamicComponent(option.icon), { key: 0 }))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", null, _toDisplayString(option.label), 1)
                ]),
                (option.selected)
                  ? (_openBlock(), _createBlock(IconCheck, { key: 0 }))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["class", "disabled", "onClick"]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ]),
    _: 3
  }, 8, ["popper-class", "placement"]))
}
}

})